<template>
   <Wrapper page-name="版本更新">
  <div class="container">
    
    <div class="update">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="手机系统" prop="clientType" >
              <el-select v-model="ruleForm.clientType" placeholder="请选择" class="width">
                <el-option label="安卓" value="0"></el-option>
                <el-option label="苹果" value="1"></el-option>
                <el-option label="鸿蒙" value="2"></el-option>
                <el-option label="其他" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="版本名称" prop="versionName">
              <el-input  v-model="ruleForm.versionName" class="width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="版本号" prop="versionCode">
              <el-input v-model="ruleForm.versionCode" class="width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否强制升级" prop="upgradeFlag">
              <el-select v-model="ruleForm.upgradeFlag" placeholder="请选择" class="width">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="版本描述" prop="upgradeDec">
              <el-input type="textarea" :rows="3" v-model="ruleForm.upgradeDec" class="width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传包文件" prop="upgradeFlag">
              <el-upload
                ref="upload"
                class="width"
                :action="url"
                :data="versionData"
                accept=".apk"
                :on-success="handleSuccess"
                :auto-upload="false"
                :headers="headers"
              >
                <el-button size="small" type="primary" style="font-size: 14px;height:33px">选取文件</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style="text-align: center;">
              <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="right-border"></div>
    </div>

    <div class="update-history">
      <Table ref="table1" v-bind="table" class="page-table" >
        <template slot="versionStatus" slot-scope="{scope}">
          <span>{{ scope.versionStatus===1?'有效':'无效'}}</span>
        </template>
        <template slot="clientType" slot-scope="{scope}">
          <span>{{ scope.clientType===0?'安卓': scope.clientType===1 ? 'IOS':'其他'}}</span>
        </template>
        <template slot="upgradeFlag" slot-scope="{scope}">
          <span>{{ scope.upgradeFlag===0?'不强制': '强制'}}</span>
        </template>
      </Table>
      <Pagination
        v-bind="pagination"
        class="page-pagination"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      />
    </div>
  </div>
</Wrapper>
</template>

<script>
import Wrapper from '@/components/page/Wrapper.vue'
import Table from '@/components/page/Table.vue'
import Pagination from '@/components/page/Pagination.vue'
import { updateUrl, getVersionList } from '@/api/versionUpdate'
export default {
  components: {
    Wrapper,
    Table,
    Pagination
  },
  data () {
    const Authorization = this.$cookie.get('Authorization')
    return {
      url: `${process.env.VUE_APP_BASE_API}${updateUrl}`,
      headers: { Authorization },
      versionData: {},
      ruleForm: {
        clientType: '0', // 0:安卓 1:ios
        versionName: '', // 版本名称
        versionCode: '', // 版本号
        upgradeFlag: '1', // 1:强制升级 0:非强制升级
        upgradeDec: ''
      },
      rules: {
        versionName: [
            { required: true, message: '必填项', trigger: 'blur' }
        ],
        versionCode: [
          {
            required: true,
            pattern: /^([1-9]\d|[1-9])(.([1-9]\d|\d)){2}$/,
            message: '版本号格式为：X.Y.Z（1-99.0-99.0-99）',
            trigger: 'blur'
          }
        ]
      },
      table: {
        selection: false, // 是否开启选择框
        batchDelete: false,
        hiddenOperate: true,
        tableInfo: [{
          key: 'versionName',
          name: '版本名称'
        }, {
          key: 'updateTime',
          name: '上传时间'
        }, {
          key: 'versionCodeStr',
          name: '版本号'
        }, {
          key: 'upgradeDec',
          name: '版本描述'
        }, {
          key: 'versionStatus',
          name: '是否有效',
          type: 'custom'
        }, {
          key: 'clientType',
          name: '手机系统',
          type: 'custom'
        }, {
          key: 'upgradeFlag',
          name: '是否强制更新',
          type: 'custom'
        }],
        tableData: [],
        height: '100%'
      },
      pagination: {
        total: 1,
        currentPage: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    params () {
      return {
        current: this.pagination.currentPage,
        size: this.pagination.pageSize
      }
    }
  },
  watch: {
    params () {
      this.getVersionList()
    }
  },
  created () {
    this.getVersionList()
  },
  methods: {
    handleSuccess (response) {
      if (response.code === '00000') {
        this.$message.success('上传成功')
      } else {
        this.$message.warning(response.msg)
      }
      this.$refs.upload.clearFiles() // 上传成功之后清除历史记录
      this.getVersionList()
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.versionData = {...this.ruleForm, versionCode: this.changtosix(this.ruleForm.versionCode)}
          const files = this.$refs.upload.uploadFiles // 判断files数组的长度是否大于0，不大于0 则未选择附件
          if (files.length === 0) {
            this.$message.warning('请选择附件')
            return
          }
          this.$nextTick(() => {
            this.$refs.upload.submit()
          })
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    changtosix (str) {
      const versionNumber = str.split('.').map((item) => {
        return item.padStart(2, '0')
      }).join('')
      return versionNumber
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    getVersionList () {
      getVersionList(this.params).then(({success, data}) => {
        if (success) {
          const { total, records } = data
          const arr = records.map((item) => {
            if (item) {
              const code = (item.versionCode + '').length === 5 ? '0' + item.versionCode : item.versionCode + ''
              const codeArr = [code.slice(0, 2), code.slice(2, 4), code.slice(4, 6)].map(num => Number(num)).join('.')
              return {...item, versionCodeStr: codeArr}
            }
          })
          this.$set(this.table, 'tableData', arr)
          this.$set(this.pagination, 'total', total)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container{
  display: flex;
  justify-content: space-between;
  width:100%;
  height:100%;
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  .update{
    position: relative;
    width: 500px;
    border-right: 20px solid #fff;
    padding-right: 36px;
    box-sizing: border-box;
    .width{
      width: 100%;
    }
    .right-border{
      position: absolute;
      right:-20px;
      top:-22px;
      height: calc(100% + 44px);
      width: 20px;
      background-color: #eee;
    }
  }
  .update-history{
    padding-right: 20px;
    height:calc(100% - 65px);
    width: calc(100% - 540px);
  }
}
.pagination-container{
  padding-top: 24px;
  margin-bottom: 0;
}
</style>